import { type RadioGroupProps as HeroUiRadioGroupProps, RadioGroup as HeroUiRadioGroup } from '@heroui/react';
import { type FC, memo } from 'react';
import { Controller, useFormContext } from 'FrontRoyalReactHookForm';

type RadioGroupProps = {
    children: React.ReactNode;
    label?: string;
    name: string;
    isDisabled?: boolean;
    className?: string;
    orientation?: HeroUiRadioGroupProps['orientation'];
    color?: HeroUiRadioGroupProps['color'];
};

export const RadioGroup: FC<RadioGroupProps> = memo(({ children, name, ...rest }) => {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <HeroUiRadioGroup {...field} {...rest}>
                    {children}
                </HeroUiRadioGroup>
            )}
        />
    );
});
